module.exports = __webpack_public_path__ + "img/Logo_el_Padronet_errada.db48f7db.png";